import { Text, View } from '@react-pdf/renderer';
import { chunk } from 'lodash-es';

import {
  VehicleInspectionReportItemTable,
  VehicleReportItem,
} from './VehicleInspectionReportItemTable';

interface VehicleInspectionReportItemsSectionProps {
  data: VehicleReportItem[];
}
export function VehicleInspectionReportItemsSection({
  data,
}: VehicleInspectionReportItemsSectionProps) {
  // Generating rows/columns because react-pdf doesn't support wrapping flex grids
  const rows = chunk(data, 10);
  const columns = chunk(rows, 2);

  return (
    <View>
      {columns.map((column, i) => {
        const [leftColumn, rightColumn] = column;

        return (
          <View
            key={i}
            style={{
              flexDirection: 'row',
              justifyContent: 'space-evenly',
              gap: 8,
            }}
          >
            <VehicleInspectionReportItemTable data={leftColumn} />
            {(rightColumn as VehicleReportItem[] | undefined)?.length ? (
              <VehicleInspectionReportItemTable data={rightColumn} />
            ) : (
              <View style={{ width: '100%' }}>
                <Text>&nbsp;</Text>
              </View>
            )}
          </View>
        );
      })}
    </View>
  );
}
